// extracted by mini-css-extract-plugin
module.exports = {"zhiboshi":"zhiboshi-S6rzuAY9","link":"link-3jZvy60h"};